import { createContext } from 'react';
import { Unit } from '../commons/interfaces/unit.interface';

interface UnitContextType {
  units: Unit[];
}

const UnitContext = createContext<UnitContextType>(null!);

export default UnitContext;
